export default __webpack_public_path__ + "static/media/OSMOS_RUGGINE_MATT_120X120_08.0b9f4263.jpg";